import { Modal }  from 'ant-design-vue'
/* 确认弹窗 */
function confirm({icon, title, content, centered}){
  return new Promise((resolve) => {
    Modal.confirm({
      title,//标题
      icon: icon || 'question-circle',//图标
      centered,//是否居中
      content: content,//内容
      onOk() {
        resolve(true)
      },
      onCancel() {
        resolve(false)
      },
      cancelText: '取消',
      okText: "确定"
    });
  })
}
export default {
  confirm,

}